// import { canUseDOM } from 'exenv';

export function jwVideoLoading(resp = {}, store = {}) {
  return {
    type: 'JW_VIDEO_LOADING',
    jwVideo: resp,
    store
  };
}

export function jwVideoLoaded(resp = {}, store = {}) {
  return {
    type: 'JW_VIDEO_LOADED',
    jwVideo: resp,
    store
  };
}

export function jwVideoLoadError(error, store = {}) {
  return {
    type: 'JW_VIDEO_ERROR',
    jwVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
